import React, { useState, useEffect } from "react";
import { Box, Fade, Typography } from "@mui/material";
import api from "../components/api";
import Map from "../components/layout/Map";
import GymCard from "../components/cards/GymCard";
import { useNavigate } from "react-router-dom";

const ExplorePage = ({ mobile, height, location, setLocation }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [gyms, setGyms] = useState([]);
  const [selectedGym, setSelectedGym] = useState(null);
  const navigate = useNavigate();

  const getGyms = async () => {
    setLoading(true);
    api.getGyms(
      (data) => {
        setGyms(data);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
        setError(true);
      }
    );
  };

  useEffect(() => {
    getGyms();
  }, []);

  const handleMarkerClicked = () => {};

  return (
    <Box
      sx={{
        height: { height },
        overflow: "scroll",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        padding: "0",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      <Map
        borderRadius="10px"
        gyms={gyms}
        initialLat={location.lat ? location.lat : -34.4111214}
        initialLon={location.lon ? location.lon : -58.7202636}
        zoom={11}
        onMarkerClicked={handleMarkerClicked}
        setSelectedGym={setSelectedGym}
        onMapDragged={() => setSelectedGym(null)}
      />
      {selectedGym && (
        <Fade in={Boolean(selectedGym)} timeout={500}>
          <Box
            style={{
              position: "absolute",
              display: "flex",
              width: "100%",
              bottom: mobile > 0 ? "90px" : "50px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              style={{
                display: "flex",
                maxWidth: "500px",
                width: "500px",
                padding: "0 10px",
                justifyContent: "center",
              }}
            >
              <GymCard
                gymName={selectedGym.name}
                gymAddress={selectedGym.address}
                gymIcon={selectedGym.iconLowResUrl}
                onClick={() => navigate(`/gimnasio/${selectedGym.id}`)}
              />
            </Box>
          </Box>
        </Fade>
      )}
    </Box>
  );
};

export default ExplorePage;
